import { render, staticRenderFns } from "./CalendarSchedules.vue?vue&type=template&id=21980a31&scoped=true"
import script from "./CalendarSchedules.vue?vue&type=script&lang=ts"
export * from "./CalendarSchedules.vue?vue&type=script&lang=ts"
import style0 from "./CalendarSchedules.vue?vue&type=style&index=0&id=21980a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21980a31",
  null
  
)

export default component.exports